export function EditIcon({
  className = "w-5 h-5",
}: {
  className?: string;
}) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M9.99998 16.6672H17.5M2.5 16.6672H3.89545C4.3031 16.6672 4.50693 16.6672 4.69874 16.6211C4.8688 16.5803 5.03138 16.513 5.1805 16.4216C5.34869 16.3185 5.49282 16.1744 5.78107 15.8861L16.25 5.41718C16.9404 4.72683 16.9404 3.60754 16.25 2.91718C15.5597 2.22682 14.4404 2.22683 13.75 2.91718L3.28105 13.3861C2.9928 13.6744 2.84867 13.8185 2.7456 13.9867C2.65422 14.1358 2.58688 14.2984 2.54605 14.4685C2.5 14.6603 2.5 14.8641 2.5 15.2718V16.6672Z" stroke="currentColor" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
}

export const displayName = "EditIcon";
